import React from 'react';
import styled from "styled-components";

const StyledInputField = styled.input`
    width: 100%;
    background-color: transparent;
    outline: none;
    border: none;

`

interface Props extends React.HTMLProps<HTMLInputElement> {
    type: "text" | "number" | "search";
    placeholder?: string;
}

const InputField: React.FC<Props> = ({type, placeholder = '', onChange, ...reset}) => {

    return (
        <StyledInputField type={type} placeholder={placeholder} onChange={onChange}
                          {...reset}
        />
    );
};

export default InputField;